"use strict";

import captchaV2 from '../captchaV2Module';

captchaV2.value('captchaIdCounter', {id:0});

